'use client';
import { useModal } from '@/components/ModalContext';
import { useOptionalProduct } from '@/contexts/ProductContext';
import SaveForLaterModal from '@/components/product/SaveForLaterModal';
import { ActionTextButton } from '../elements/WebLink';

const SaveForLater = ({ block = {}, align = 'center', size = 'base' }) => {
  const { title = "" } = block;
  const { openModal } = useModal();
  const product = useOptionalProduct();

  return (
    <ActionTextButton
      align={align}
      size={size}
      onClick={() =>
        openModal(
          <SaveForLaterModal
            productData={product?.productData}
            selectedVariant={product?.selectedVariant}
          />,
        )
      }
      label={title}
    />
  );
};

export default SaveForLater;
